export const environment = {
  production: true,
  environmentName: 'prod',
  apiUrl: "/portalApi",
  steamApiUrl: "/steamApi",
  paymentApiUrl: "/paymentapi",
  cccApiUrl: "/cccapi",
  pockytApiUrl: "/pockytapi",
  achApiUrl: "/achapi",
  invoiceApiUrl: "/invoiceapi",
  secretKey: "1995",
  isSwitchTPN: true,
  usePosParamCacheApi: true,
  apiFullUrl: "https://api.ipospays.com/v1",
  portalUrl: "https://portal.ipospays.com",
  steamApiFullUrl: "https://steam.ipospays.com/v1",
  portalImagePath: "assets/images",
  portalMerchantLogoPath: "https://portal.ipospays.com/portalApi/assets/images/merchantlogos",
  steamImagePath:"../../../data/steam/assets/images",
  dateFormat: "MM-DD-yyyy",
  dateTimeFormat: "MM-DD-yyyy - HH:mm:ss",
  displayTimeZone: 'America/New_York',
  autoLogoutTime: 240,
  checkInterval: 1000,
  inspect: false,
  minorChannel : {
    0: "POS Terminal",
    1: "SPIN-LOCAL",
    2: "SPIN-CLOUD",
    3: "PINPAD",
    4: "E-Commerce",
    5: "RECURRING-PAYMENT",
    6: "INVOICE-PAYMENT",
    7: "CUSTOMER-PAYMENT",
    8: "Tap on phone",
    9: "EXTERNAL-ECOM",
    10: "ACH",
    11: "GHPP",
    12: "POS-CUSTOMER-PAYMENT",
    13: "CP-PINPAD",
    14: "Google Pay",
    15: "External E-Commerce-FTD",
    16: "Econduit",
    17: "WooCommerce-Redirect",
    18 : "Apple Pay",
    19: "WooCommerce-Embedded",
    20: "Deep Linking iOS",
    21: "In-App SDK iOS",
    22 : "WooCommerce",
    23 : "WooCommerce Embedded Google pay",
    24 : "Paypal",
    25 : "Venmo",
    26 : "Crypto",
    27 : "USB",
    28 : "SPIN-USB"
    // If adding new value for minor channel, Need to add values in Portal API --> utils --> minor Channel object

  },
  POSMode: {
    "100": "COF",
    "110": "CONTACTLESS",
    "112": "CONTACTLESS",
    "710": "CONTACTLESS",
    "711": "CONTACTLESS",
    "712": "CONTACTLESS",
    "800": "SWIPE",
    "801": "SWIPE",
    "802": "SWIPE",
    "900": "SWIPE",
    "901": "SWIPE",
    "902": "SWIPE",
    "071": "CONTACTLESS",
    "010": "MANUAL",
    "011": "MANUAL",
    "012": "MANUAL",
    "050": "CHIP",
    "051": "CHIP",
    "052": "CHIP",
    "004": "CHECK"
  },
  qbDesc: {
    "1": "Production Settings",
    "2": true,
    "3": true
  },
  spinServer:'https://z2spin.spinpos.net/',
  pagoServer:'https://ipos-gateway.test.pago.dev/',
  enableClientError:false,
  keySize : 256,
  ivSize : 128,
  iterations : 100,
  defaultLogo:'https://portal.ipospays.com/portalApi/assets/images/defaultLogo/iPOSpays.png',
  CAPTCHA_SITE_KEY:'6Ld9ScEpAAAAAFFw8A62sNSW5Z9T0tGj4224SLEh',
  version: "4",
  whitelabelLogoPath: "https://portal.ipospays.com/portalApi/assets/images/whitelabelImages",
  defaultPaymentDomain:"https://payment.ipospays.com",
  defaultIcon:"https://portal.ipospays.com/assets/images/iPOS.png",
  defaultPaymentTabName:"IPOSpays Payment Form",
  apiDocsLink: "https://docs.ipospays.com",
  knowledgeBaseLink: "https://knowledge.ipospays.com/",
  releaseNotesLink: "https://releases.ipospays.com/",
  payaEntryClasses:{
    'PPD':'PERSONAL',
    'CCD':'BUSINESS'
  },
  brandingUrl :"https://pay.ipospays.com/branding",
  paymentGatwayApi:"https://pay.ipospays.com",
  vipUrl: "https://dejaup.ipospays.com",
  enableDemoCredentials: false,
  ACH: {
   
  },
  PAYAACH: {
  },
  VERICHECKACH: {
  },
  SUBMIT_WINDOW_MS: 10 * 60 * 1000,
  
};